define.alias("shared/components/shared/carousel/inner", "calendar/components/shared/carousel/inner");